import { CarriageRequest, generalTrip, infoUnitTypeRel } from "types";
import {fetchData} from 'config/api/api';
import env from "react-dotenv";

const getGeneralTrips = async()=>{
    const url = `${env.REACT_APP_BACKEND}/get-general-trips`;
    const response = await fetchData(url)
    let trips: generalTrip[] = [];
    response.forEach((element:any) => {
        const cityDestiny = element.CityDestiny? element.CityDestiny.Name as string : "Not found"
        const cityDestinyState = element.CityDestiny? element.CityDestiny.State as string : "Not found"
        trips.push({
            cityOrigin:element.CityOrigin.Name as string,
            cityDestiny: cityDestiny,
            unitType:element.UnitType.Description as string,
            eta:element.Eta as string,
            hasMultipleLocation:element.MultipleLocation as boolean,
            hasReturn:element.CloseCircuit,
            lastResponse: element.LastResponse as string | null,
            cityDestinyState:cityDestinyState,
            cityOriginState:element.CityOrigin.State as string,
            id:element.IdCarriage,
            updatedAt:element.UpdatedAt,
            CarriageRequest:element.carriageRequest as CarriageRequest,
            infoUnitTypeRel:element.infoUnitTypeRel ? element.infoUnitTypeRel as infoUnitTypeRel : undefined
        })
    });
    return trips;
}

const getCompletedTrips = async()=>{
    const url = `${env.REACT_APP_BACKEND}/complete-carriages`;
    const response = await fetchData(url)
    let trips: generalTrip[] = [];
    response.forEach((element:any) => {
        const cityDestiny = element.CityDestiny? element.CityDestiny.Name as string : "Not found"
        const cityDestinyState = element.CityDestiny? element.CityDestiny.State as string : "Not found"
        const carrierName = element.CupCarrier ? element.CupCarrier.Name as string : "Not found"
        trips.push({
            cityOrigin:element.CityOrigin.Name as string,
            cityDestiny: cityDestiny,
            unitType:element.UnitType.Description as string,
            eta:element.Eta as string,
            hasMultipleLocation:element.MultipleLocation as boolean,
            hasReturn:element.CloseCircuit,
            lastResponse: element.LastResponse as string | null,
            cityDestinyState:cityDestinyState,
            cityOriginState:element.CityOrigin.State as string,
            id:element.IdCarriage,
            carrier:carrierName,
            infoUnitTypeRel:element.infoUnitTypeRel ? element.infoUnitTypeRel as infoUnitTypeRel : undefined
        })
    });
    return trips;
}

const getRejectedTrips = async()=>{
    const url = `${env.REACT_APP_BACKEND}/rejected-carriages`;
    const response = await fetchData(url)
    let trips: generalTrip[] = [];
    response.forEach((element:any) => {
        const cityDestiny = element.CityDestiny? element.CityDestiny.Name as string : "Not found"
        const cityDestinyState = element.CityDestiny? element.CityDestiny.State as string : "Not found"
        const carrierName = element.CupCarrier ? element.CupCarrier.Name as string : "Not found"
        trips.push({
            cityOrigin:element.CityOrigin.Name as string,
            cityDestiny: cityDestiny,
            unitType:element.UnitType.Description as string,
            eta:element.Eta as string,
            hasMultipleLocation:element.MultipleLocation as boolean,
            hasReturn:element.CloseCircuit,
            lastResponse: element.LastResponse as string | null,
            cityDestinyState:cityDestinyState,
            cityOriginState:element.CityOrigin.State as string,
            id:element.IdCarriage,
            carrier:carrierName,
            infoUnitTypeRel:element.infoUnitTypeRel ? element.infoUnitTypeRel as infoUnitTypeRel : undefined
        })
    });
    return trips;
}

const getAcceptedTrips = async()=>{
    const url = `${env.REACT_APP_BACKEND}/get-accepted-trips`;
    const response = await fetchData(url)
    let trips: generalTrip[] = [];
    response.forEach((element:any) => {
        const cityDestiny = element.CityDestiny? element.CityDestiny.Name as string : "Not found"
        const cityDestinyState = element.CityDestiny? element.CityDestiny.State as string : "Not found"
        const carrierName = element.CupCarrier ? element.CupCarrier.Name as string : "Not found"
        trips.push({
            cityOrigin:element.CityOrigin.Name as string,
            cityDestiny: cityDestiny,
            unitType:element.UnitType.Description as string,
            eta:element.Eta as string,
            hasMultipleLocation:element.MultipleLocation as boolean,
            hasReturn:element.CloseCircuit,
            lastResponse: element.LastResponse as string | null,
            cityDestinyState:cityDestinyState,
            cityOriginState:element.CityOrigin.State as string,
            id:element.IdCarriage,
            carrier:carrierName,
            infoUnitTypeRel:element.infoUnitTypeRel ? element.infoUnitTypeRel as infoUnitTypeRel : undefined
        })
    });
    return trips;
}

export{
    getGeneralTrips,
    getCompletedTrips,
    getRejectedTrips,
    getAcceptedTrips,
}